import { QueryObserverBaseResult, useQuery } from "react-query";
import { queryKeys } from "../../query";
import api, { createURLParams } from "../../client";
import { InteractionListResponseData } from "../../types/interaction";
import { QueryParams } from "../../types/base";

export const getData = async (params: QueryParams) => {
  const { data } = await api.get<InteractionListResponseData>(
    `/interactions${createURLParams(params)}`,
  );

  return data;
};

export const useInteractions = (
  params: QueryParams,
): QueryObserverBaseResult<InteractionListResponseData> => {
  const { data, ...props } = useQuery(
    queryKeys.interactionListPage(params),
    () => getData(params),
  );
  return { data, ...props };
};
